var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image__preview"},[_c('el-image-viewer',{ref:"imageDom",attrs:{"on-close":_vm.closeViewer,"maskClosable":_vm.maskClosable,"url-list":_vm.urls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }